// Dev Server- Put IP address of your local machine if localhost doesn't work
// const BaseUrl = "http://localhost:5001";

// Admin panel uses the dedicated backend
const BaseUrl = "https://preprod-api.collegetpoint.in";

let AppSettings = /** @class */ (() => {
  class AppSettings {}
  AppSettings.server = {
    baseUrl: BaseUrl,
  };
  return AppSettings;
})();
export { AppSettings };
